import { render } from "./ProjetcView.vue?vue&type=template&id=f31a9e8e"
import script from "./ProjetcView.vue?vue&type=script&lang=js"
export * from "./ProjetcView.vue?vue&type=script&lang=js"
script.render = render

export default script